import './BarcodeScannerItem.scss';

import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import Picture from '@/common/components/atoms/Picture/Picture';
import Quantity from '@/common/components/molecules/Quantity/Quantity';
import { ROLES, ROUTE_SCANBAT, SOURCE } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import getImageBySize from '@/common/helpers/getImageBySize';
import ProductPrice from '@/ebat/components/blocks/Common/Product/ProductPrice/ProductPrice';
import { PRODUCTS_TYPES_FORMATS } from '@/ebat/constants';

import Loader from '../../Common/Loader/Loader';
import {
  BarcodeScannerItemDefaultProps,
  BarcodeScannerItemPropTypes,
} from './BarcodeScannerItem.proptypes';

const BarcodeScannerItem = ({
  className,
  customerPrice,
  discountPrice,
  discountPriceTTC,
  brand,
  ebatExists,
  image,
  publicPriceTTC,
  manufacturerSku,
  name,
  id,
  isLoading,
  invoiceUnit,
  isVisible,
  publicPrice,
  salesPackaging,
  splitPackaging,
  saleUnit,
  sku,
  onValidatePopin,
  setIsVisible,
}) => {
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(null);
  const { isShowNetPrice, user } = useAuth();
  const isScanbat = window.location.pathname.includes(ROUTE_SCANBAT);

  useEffect(() => {
    setQuantity(salesPackaging && !splitPackaging ? salesPackaging : 1);
  }, [salesPackaging, splitPackaging]);

  let displayedPrice = 'public';
  if (user.role === ROLES.CUSTOMER_GUEST) {
    displayedPrice = 'ttc';
  } else if (isScanbat || isShowNetPrice) {
    displayedPrice = 'customer';
  }

  return (
    <div
      className={cn(className, 'barcode-scanner-item', { visible: isVisible })}
    >
      {isLoading ? (
        <Loader className="barcode-scanner-item-loader" type="full" />
      ) : (
        <>
          <div className={cn('barcode-scanner-item__detail')}>
            <div className={cn('detail', 'detail__image')}>
              <Picture
                className="product__image"
                alt={image?.alt}
                src={
                  image?.url
                    ? getImageBySize(image.url, PRODUCTS_TYPES_FORMATS.MOSAIC)
                    : ''
                }
              />
            </div>
            <div className={cn('detail', 'detail__description')}>
              <span className={cn('description', 'description__title')}>
                {name}
              </span>
              <div className={cn('description', 'description__infos')}>
                <span className={cn('infos', 'infos__code')}>
                  {t('common:entities:product.sku')}
                  {sku}
                </span>
                <span className={cn('infos', 'infos__ref')}>
                  {t('common:entities:product.manufacturer_sku')}
                  {manufacturerSku}
                </span>
              </div>
              <div className="description__prices">
                {displayedPrice === 'customer' && (
                  <ProductPrice
                    className="description__net-price"
                    discountPrice={discountPrice}
                    invoiceUnit={invoiceUnit}
                    label={t('common:entities:product.price.customer_price')}
                    price={customerPrice}
                    showEmptyLabel
                  />
                )}
                {displayedPrice === 'public' && (
                  <ProductPrice
                    className="description__net-price"
                    invoiceUnit={invoiceUnit}
                    label={t('common:entities:product.price.public_price')}
                    price={publicPrice}
                    discountPrice={
                      user.role === ROLES.CUSTOMER_GUEST && discountPrice
                    }
                    showEmptyLabel
                  />
                )}
                {displayedPrice === 'ttc' && (
                  <ProductPrice
                    className="description__net-price"
                    invoiceUnit={invoiceUnit}
                    label={t('common:entities:product.price.public_price_ttc')}
                    price={publicPriceTTC}
                    discountPrice={discountPriceTTC}
                    showEmptyLabel
                  />
                )}
              </div>
            </div>
          </div>
          <div className={cn('barcode-scanner-item__action')}>
            <span className={cn('action', 'action__title')}>
              {t('common:messages:actions.select_quantity')}
            </span>
            <Quantity
              className="action__quantity"
              id={id}
              onChange={(data) => setQuantity(data.quantity)}
              quantity={quantity}
              salesPackaging={salesPackaging}
              splitPackaging={splitPackaging}
              unit={saleUnit}
            />
            <Button
              buttonSize="medium"
              className="action__validate"
              variant="primary"
              onClick={() => {
                onValidatePopin([
                  {
                    brand,
                    name,
                    quantity,
                    sku,
                    ebat_exists: ebatExists,
                    source: SOURCE.QUICK_ENTRY,
                  },
                ]);
                setIsVisible(false);
              }}
            >
              {t('common:messages:actions.valid')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
BarcodeScannerItem.defaultProps = {
  ...BarcodeScannerItemDefaultProps,
};

BarcodeScannerItem.propTypes = {
  ...BarcodeScannerItemPropTypes,
};

export default BarcodeScannerItem;
